import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { MULTI_SITE_ANALYSIS_ROUTES } from './multi-site-analysis.route';
import { MultiSiteAnalysisComponent } from './multi-site-analysis.component';
import { MultiSiteAnalysisService } from './multi-site-analysis.service';
import { MultiSiteAnalysisContext } from './multi-site-analysis.context';
import { MultiSiteStudyComponent } from './multi-site-study.component';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    declarations: [
        MultiSiteAnalysisComponent,
        MultiSiteStudyComponent
    ],
    providers: [
        MultiSiteAnalysisService,
        MultiSiteAnalysisContext
    ],
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(MULTI_SITE_ANALYSIS_ROUTES),
        HelpLinkComponent
    ]
})
export class MultiSiteAnalysisModule {
}
